/* import HtmlToCanvas from 'html2canvas' */
import JsPDF from 'jspdf'
import 'jspdf-autotable'
import moment from 'moment'

export default {
  Dashboard: async (
    nomeRelatorio,
    informacoes,
    colsIndicadores,
    rowsIndicadores,
    colsBinarios,
    rowsBinarios,
    colsMultipla,
    rowsMultipla,
    colsBarras,
    rowsBarras,
    orientation,
  ) => {
    moment.locale()
    var time = moment().format('LLL')
    var logoMilkPlan = new Image()
    logoMilkPlan.src = 'img/logo-pdf.png'

    var doc = new JsPDF(orientation)
    var pageSize = doc.internal.pageSize
    var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
    var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth()
    var totalPagesExp = '{total_pages_count_string}'

    doc.addImage(
      logoMilkPlan,
      'PNG',
      pageWidth - 25,
      10,
      15,
      10,
      'LogoMilkPlan',
    )

    doc.setFontSize(16)
    doc.text(nomeRelatorio, 9.7, 15)

    var posX = 10
    var posY = 21
    var incrementoX = 7
    var incrementoY = 5
    var flgWidthLinha = 0
    doc.setFontSize(10)
    for (let index = 0; index < informacoes.length; index++) {
      var stringLen = doc.getTextWidth(informacoes[index], {})
      if (flgWidthLinha + stringLen < pageWidth - 10) {
        doc.text(informacoes[index], posX, posY)
        posX += stringLen + incrementoX
        flgWidthLinha += stringLen + incrementoX
      } else {
        posX = 10
        posY += incrementoY
        flgWidthLinha = 0
        doc.text(informacoes[index], posX, posY)
      }
    }

    posY += incrementoY
    doc.autoTable(colsIndicadores, rowsIndicadores, {
      margin: {top: posY, right: 9, left: 10},
      theme: 'striped',
      styles: {fontSize: 8},
      headStyles: {fontSize: 10, fillColor: '#28416a'},
      didDrawPage: function () {
        var str = 'Página ' + doc.internal.getNumberOfPages()
        if (typeof doc.putTotalPages === 'function') {
          str =
            str +
            ' de ' +
            totalPagesExp +
            '\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t' +
            'http://www.milkplan.com.br'
        }
        doc.setFontSize(8)

        doc.text(str, 11.3, pageHeight - 6)
        doc.text(
          time,
          pageWidth - 10 - doc.getTextWidth(time, {}),
          pageHeight - 6,
        )
      },
    })

    doc.autoTable(colsBinarios, rowsBinarios, {
      margin: {top: posY, right: 9, left: 10},
      theme: 'striped',
      styles: {fontSize: 8},
      headStyles: {fontSize: 10, fillColor: '#28416a'},
      didDrawPage: function () {
        var str = 'Página ' + doc.internal.getNumberOfPages()
        if (typeof doc.putTotalPages === 'function') {
          str =
            str +
            ' de ' +
            totalPagesExp +
            '\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t' +
            'http://www.milkplan.com.br'
        }
        doc.setFontSize(8)

        doc.text(str, 11.3, pageHeight - 6)
        doc.text(
          time,
          pageWidth - 10 - doc.getTextWidth(time, {}),
          pageHeight - 6,
        )
      },
    })

    doc.autoTable(colsMultipla, rowsMultipla, {
      margin: {top: posY, right: 9, left: 10},
      theme: 'striped',
      styles: {fontSize: 8},
      headStyles: {fontSize: 10, fillColor: '#28416a'},
      didDrawPage: function () {
        var str = 'Página ' + doc.internal.getNumberOfPages()
        if (typeof doc.putTotalPages === 'function') {
          str =
            str +
            ' de ' +
            totalPagesExp +
            '\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t' +
            'http://www.milkplan.com.br'
        }
        doc.setFontSize(8)

        doc.text(str, 11.3, pageHeight - 6)
        doc.text(
          time,
          pageWidth - 10 - doc.getTextWidth(time, {}),
          pageHeight - 6,
        )
      },
    })

    doc.autoTable(colsBarras, rowsBarras, {
      margin: {top: posY, right: 9, left: 10},
      theme: 'striped',
      styles: {fontSize: 8},
      headStyles: {fontSize: 10, fillColor: '#28416a'},
      didDrawPage: function () {
        var str = 'Página ' + doc.internal.getNumberOfPages()
        if (typeof doc.putTotalPages === 'function') {
          str =
            str +
            ' de ' +
            totalPagesExp +
            '\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t' +
            'http://www.milkplan.com.br'
        }
        doc.setFontSize(8)

        doc.text(str, 11.3, pageHeight - 6)
        doc.text(
          time,
          pageWidth - 10 - doc.getTextWidth(time, {}),
          pageHeight - 6,
        )
      },
    })

    if (typeof doc.putTotalPages === 'function') {
      doc.putTotalPages(totalPagesExp)
    }

    doc.save(nomeRelatorio + '-' + time + '.pdf')
  },
}
